const Notificaciones = () => {

  return (
    <div className="m-auto md:w-[80%]">
      <div className="grid grid-cols-2 gap-2">
        <div className="py-4">
          <span className="text-primary font-bold text-xl mb-4 block">Notificaciones</span>
          <div className="flex justify-between mb-4">
            <div>
              <span className="block font-bold">Actividad de la cuenta y politicas</span>
              <span>Confirmá las reservas, consulta la actividad de tu cuenta y descubrí las politicas más importantes de Rumbo Punilla.</span>
            </div>
          </div>

          <div className="flex justify-between mb-4">
            <div>
              <span className="block font-bold">Actividad de la cuenta</span>
              <span>Activadas: Correo electronico y mensaje de texto</span>
            </div>

            <label className="font-bold cursor-pointer">
              Editar
              <button className="hidden"></button>
            </label>
          </div>

          <div className="flex justify-between mb-4">
            <div>
              <span className="block font-bold">Actividad del anuncio</span>
              <span>Activadas: Correo electronico y mensaje de texto</span>
            </div>

            <label className="font-bold cursor-pointer">
              Editar
              <button className="hidden"></button>
            </label>
          </div>

          <div className="flex justify-between mb-4">
            <div>
              <span className="block font-bold">Politicas de los huéspedes</span>
              <span>Activadas: Correo electronico y mensaje de texto</span>
            </div>

            <label className="font-bold cursor-pointer">
              Editar
              <button className="hidden"></button>
            </label>
          </div>

          <div className="flex justify-between mb-4">
            <div>
              <span className="block font-bold">Politicas relacionadas con los anfitriones</span>
              <span>Activadas: Correo electronico y mensaje de texto</span>
            </div>

            <label className="font-bold cursor-pointer">
              Editar
              <button className="hidden"></button>
            </label>
          </div>

          <hr />

          <div className="flex justify-between mb-4">
            <div>
              <span className="block font-bold">Recordatorio</span>
              <span className="block">Recibí recordatorios importantes de tus reservas, tus anuncios y la actividad de tu cuenta.</span>
              <span className="block font-bold">Recordatorio</span>
              <span className="block">Activadas: Correo electronico y mensaje de texto.</span>
            </div>

            <label className="font-bold cursor-pointer">
              Editar
              <button className="hidden"></button>
            </label>
          </div>
          <hr />
          <div className="flex justify-between mb-4">
            <div>
              <span className="block font-bold">Mensaje de los viajeros y anfitriones</span>
              <span className="block">Mantenete en contacto con el anfitrion o los viajeros antes y durante el viaje.</span>
            </div>
          </div>


        </div>
        <div></div>
      </div>
    </div>
  )
}

export default Notificaciones